import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import { fetchVisitHistory as fetchVisitHistoryRoutine } from './routines';

export const fetchVisitHistory = ({ payload: body }) =>
  sagaRoutineRequest(fetchVisitHistoryRoutine, {
    request: () => call(Api.fetchVisitHistory, { body })
  });
